import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule, routedComponents } from './pages-routing.module';
import { CoreModule } from '@core/core.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [...routedComponents],
  imports: [
    CommonModule,
    PagesRoutingModule,
    CoreModule,
    RouterModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    NgxPaginationModule,
    TranslateModule
  ],
  providers: [provideNgxMask()],
})
export class PagesModule {
}
